import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html'
})
export class LoadingComponent implements OnInit {
  show: boolean = false;

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/_foundation/components/loading/loading.component.ts